<template>
  <div class="patient_content-wrapper">
    <progress-bar></progress-bar>
    <!--  MOBILE SECTION HEAD  -->
    <section-head :patient="'gabrielle'" v-if="this.userAgent.window.width < 1024"></section-head>
    <!--    -->

    <!--  S1  -->
    <section-wrapper
        :class="this.GabrielleQuizData.name + '_patient_section_1'"
        :id="1"
        :patientName="this.GabrielleQuizData.name">
      <template slot="section">
        <div class="section first-section">

          <h1 class="patient-title">Meet Gabrielle*</h1>

          <h3 class="patient-description" v-html="this.GabrielleData.story"></h3>

          <div class="text_container">
            <p class="text">Interested in managing her perennial symptoms with a therapy that reduces symptom and medication burden.</p>
          </div>

          <div class="title_container">
            <h2 class="section-title">History and Presenting Symptoms</h2>
          </div>

          <div class="double_container reversed">
            <div class="double_container-left">
              <div class="icon_container">

                <div class="icon-item">

                  <div class="icon-item--left">
                    <img alt class="icon-item-image" src="@/assets/img/patients/family-history.svg">
                  </div>
                  <div class="icon_container--right">
                    <p class="text text--icon-title">Family History:</p>
                    <p class="text text--icon-description">Dad had AR and CAD; sister has eczema</p>
                  </div>

                </div>

                <div class="icon-item">
                  <div class="icon-item--left">
                    <img alt class="icon-item-image" src="@/assets/img/patients/social-history.svg">
                  </div>
                  <div class="icon_container--right">
                    <p class="text text--icon-title">Social History:</p>
                    <p class="text text--icon-description">In home: hypoallergic dog; rugs; no carpeting</p>
                  </div>
                </div>

                <div class="icon-item pb-0">
                  <div class="icon-item--left">
                    <img alt class="icon-item-image" src="@/assets/img/patients/medical-history.svg">
                  </div>
                  <div class="icon_container--right">
                    <p class="text text--icon-title">Medical History</p>
                    <ul class="ul_container">
                      <li class="text li-item">History of perennial AR; symptoms flare up every spring and then again in late summer</li>
                      <li class="text li-item">History of facial pressure, runny nose, scratchy sore throat, nasal congestion, difficulty breathing while sleeping, cough, itchy watery eyes, and ear pressure</li>
                      <li class="text li-item">Over-the-counter antihistamines and glucocorticoid nasal sprays were ineffective at providing relief from symptoms</li>
                      <li class="text li-item">Current medications include prescribed nasal corticosteroids, oral corticosteroids, oral antihistamines, decongestant, and occasional “blast” of corticosteroids for the last couple of years with
                        limited
                        symptom relief
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
            <div class="double_container-right">
              <div class="video_block_container">
                <div class="video_block-content">

                  <div class="video_head">
                    <p class="video-title">EXPERT’S OPINION</p>
                  </div>
                  <div class="video_block" @click="toggleModal('modal-video')">

                    <img class="video-thumbnail" src="@/assets/img/video/thumbnail_gabrielle.png" alt>
                    <img class="video-playButton" src="@/assets/img/video/play_button.svg" alt>

                  </div>
                  <div class="video_footer">
                    <div class="video_footer-left">
                      <img class="health-image" :src="this.GabrielleData.docImage" alt>
                    </div>
                    <div class="video_footer-right">
                      <p class="health-description" v-html="this.GabrielleData.docDesc"></p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="footnotes_container pt-10">
            <p class="text text--footnote">AR=allergic rhinitis; CAD=coronary artery disease.</p>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">Initial Examination</h2>
          </div>

          <div class="icon_container js-botTopFadeIn">
            <div class="icon-item pb-0">
              <div class="icon-item--left">
                <img alt class="icon-item-image" src="@/assets/img/patients/initial-treatment.svg">
              </div>
              <div class="icon_container--right">
                <ul class="ul_container">
                  <li class="text li-item pt-0">Upon examination, Gabrielle had AR, allergic conjunctivitis, inferior turbinate hypertrophy and posterior rhinorrhea</li>
                  <li class="text li-item">Skin prick test revealed a positive reaction to trees (2+), grasses (2+), <nobr>mold (2+), </nobr> weeds (1+), and dust mites (3+)</li>
                  <li class="text li-item">SNOT-22 questionnaire score of 4 (severe problem)</li>
                  <li class="text li-item">Investigation revealed significant perennial allergy</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="footnotes_container pt-10 js-botTopFadeIn">
            <p class="text text--footnote">SNOT-22=sino-nasal outcome test-22.</p>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">Diagnosis</h2>
          </div>

          <div class="icon_container js-botTopFadeIn">
            <div class="icon-item pb-0">
              <div class="icon-item--left">
                <img alt class="icon-item-image" src="@/assets/img/patients/diagnosis.svg">
              </div>
              <div class="icon_container--right">
                <ul class="ul_container">
                  <li class="text li-item pt-0">Perennial AR testing positive to multiple aeroallergens, AR, conjunctivitis, and inferior turbinate hypertrophy, which worsens during spring and late summer</li>
                </ul>
              </div>
            </div>
          </div>

          <quote :patient="'gabrielle'" :blockID="1" class="js-botTopFadeIn"></quote>

          <div class="title_container pt-0 js-botTopFadeIn">
            <h2 class="section-title">Initial TREATMENT</h2>
          </div>

          <div class="icon_container js-botTopFadeIn">
            <div class="icon-item pb-0">
              <div class="icon-item--left">
                <img alt class="icon-item-image" src="@/assets/img/patients/initial-treatment.svg">
              </div>
              <div class="icon_container--right">
                <ul class="ul_container">
                  <li class="text li-item pt-0">Discontinue oral steroids and nasal spray due to side effects</li>
                  <li class="text li-item">Control Gabrielle’s AR with daily use nasal antihistamines in combination with an oral antihistamine</li>
                  <li class="text li-item">Alleviate allergic conjunctivitis symptoms with eye drops as needed</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">Follow-up</h2>
          </div>

          <ul class="ul_container js-botTopFadeIn">
            <li class="text li-item">Not all Gabrielle’s symptoms were controlled with added treatment</li>
          </ul>

          <quote :patient="'gabrielle'" :blockID="2" class="js-botTopFadeIn"></quote>

        </div>
        <quiz :patientName="this.GabrielleQuizData.name" :id='1'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', 'section-divider-active']"></div>

    <!--  S2  -->
    <section-wrapper
        :class="this.GabrielleQuizData.name + '_patient_section_2'"
        :id="2"
        :patientName="this.GabrielleQuizData.name">
      <template slot="section">
        <div class="section">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.GabrielleQuizData.question[1].answered === true" id="tip_1">

            <div class="image_container pt-0 pb-0">
              <img v-if="this.userAgent.window.width >= 1024" src="https://res.cloudinary.com/haymarket-pri/image/upload/v1600253825/alk_odactra_pj/9/0.png" alt class="image full-image">
              <img v-else src="https://res.cloudinary.com/haymarket-pri/image/upload/v1600254152/alk_odactra_pj/9_mob/9_mob.png" alt class="image full-image">
            </div>

            <div class="footnotes_container">
              <p class="text text--footnote">OTC=over-the-counter; <nobr>SCIT=subcutaneous</nobr> immunotherapy; <nobr>SLIT=sublingual</nobr> immunotherapy.</p>
            </div>

            <div class="footnotes_container">
              <p class="text text--footnote">Reference: 1. ALK-Abelló A/S Data on file.</p>
            </div>
          </div>
          </transition>

          <div class="text_container pt-0 js-botTopFadeIn">
            <p class="text">Patients allergic to house dust mites (HDM) need options for AIT because, by the time patients see an allergist, they have experienced a long patient journey. HDMs are almost ubiquitous and one of the
              most common and generally unavoidable sources of indoor allergens. Even low levels of exposure to HDM-allergenic proteins can trigger hypersensitivity.<sup>2-5</sup></p>
          </div>

          <div class="text_container js-botTopFadeIn">
            <p class="block-black-title pb-0">Changes in Treatment</p>
            <ul class="ul_container pt-0">
              <li class="li-item text">Long-term treatment options were discussed to maximize therapeutic success</li>
              <li class="li-item text">Not amenable to SCIT due to delayed onset of efficacy for ~6 months to a year</li>
            </ul>
          </div>

          <quote :patient="'gabrielle'" :blockID="3" class="js-botTopFadeIn"></quote>

          <div class="text_container pt-0 js-botTopFadeIn">
            <p class="section-title">ODACTRA<sup>®</sup> is the first and only FDA-approved sublingual tablet for HDM-induced AR, with or without conjunctivitis</p>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <p class="section-title">Indication</p>
          </div>

          <div class="text_container pt-0 pb-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item">ODACTRA<sup>®</sup> is an immunotherapy for HDM-induced AR, with or without conjunctivitis, confirmed by <i>in vitro</i> testing for IgE antibodies to <i>Dermatophagoides farinae</i> or <i>Dermatophagoides
                pteronyssinus</i> HDMs, or skin testing to licensed HDM allergen extracts
              </li>
              <li class="text li-item">For use in adults 18 through 65 years of age</li>
            </ul>
          </div>

          <div class="footnotes_container pt-10 js-botTopFadeIn">
            <p class="text text--footnote">IgE=immunoglobulin E.</p>
          </div>

        </div>
        <quiz :patientName="this.GabrielleQuizData.name" :id='2'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.GabrielleQuizData.question[1].answered === true}]"></div>

    <!--  S3  -->
    <section-wrapper
        :class="this.GabrielleQuizData.name + '_patient_section_3'"
        :id="3"
        :patientName="this.GabrielleQuizData.name">
      <template slot="section">
        <div class="section">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.GabrielleQuizData.question[2].answered === true" id="tip_2">
              <p class="text text--quiz-info">ODACTRA<sup>®</sup> significantly reduced nasal and ocular symptoms as early as <nobr>8 to 14 weeks.<sup>6-8</sup></nobr></p>
            </div>
          </transition>

          <div class="text_container pt-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="li-item text">Statistically significant reductions in the nasal symptoms of AR occurred as early as week 8 and continued to improve toward week 24, the primary end point<sup>6-7</sup></li>
            </ul>
          </div>

          <patient-tabs :tabData="this.tabDataGabrielle[1]" class="js-botTopFadeIn"></patient-tabs>

          <div class="footnotes_container js-botTopFadeIn">
            <p class="text text--footnote"><nobr>IgG4=immunoglobulin</nobr> G <nobr>subclass 4;</nobr> <nobr>TNSS=total</nobr> nasal symptom score.</p>
            <p class="text text--footnote superscript-in-text"><span class="sup">*</span>TNSS is defined as a total score comprising the following: rhinorrhea, nasal congestion, nasal itching, and sneezing.<br/>
              IgG4 levels increased with ODACTRA<sup>®</sup> vs placebo at week 8 based on the prespecified analyses (<i class="mr-1">P</i><.001).<sup>6</sup></p>
          </div>

          <div class="text_container pt-40 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="li-item text">Significant improvements in ocular symptoms (a secondary end point) relative to placebo were observed at weeks 8 and 24 for ODACTRA vs placebo<sup>6</sup></li>
            </ul>
          </div>

          <patient-tabs :tabData="this.tabDataGabrielle[2]" class="js-botTopFadeIn"></patient-tabs>

          <accordion :group="'gabrielleGroup1'" :initialShow="true" :id="1" class="accordion accordion-1 js-botTopFadeIn">
            <template slot="header">
              <p class="accordion_title unselectable">Study design</p>
              <img src="@/assets/img/accordion/arrow-bottom.svg" alt class="accordion-toggle unselectable">
            </template>
            <template slot="body">
              <p class="text text--footnote">A randomized, single-site, placebo-controlled, double-blind, onset-of-action trial was conducted for <nobr>24 weeks</nobr> in adults <nobr>aged ≥18 years</nobr> with
                HDM-induced AR/conjunctivitis, with or without asthma (N=83; ODACTRA<sup>®</sup> =42, placebo=41), using the Vienna Challenge Chamber. Mean age (years/range) <nobr>was 28 (18-58)</nobr> for the ODACTRA<sup>®</sup> patients and 27
                (19-43)
                for
                placebo patients. Mean
                duration of AR/conjunctivitis was <nobr>16 years</nobr> and <nobr>17 years</nobr> for ODACTRA<sup>®</sup> and placebo patients, respectively. Of ODACTRA<sup>®</sup> patients, 88% were polysensitized. Patients received
                ODACTRA<sup>®</sup>
                or placebo and symptoms were scored every 15 minutes during exposure challenges, which occurred at screening and at <nobr>weeks 8, 16, and 24.</nobr>
                The primary efficacy end point was the average TNSS at week 24, which was the sum of the 4 nasal symptoms (runny nose, blocked nose, sneezing, and itchy nose), with a maximum score of 12. A key secondary end point was the average
                TOSS
                at <nobr>weeks 8, 16, and 24.</nobr> The TOSS was the sum of the 2 ocular symptoms (gritty/red/itchy eyes and watery eyes). There were 10 patients and 9 patients with asthma (ODACTRA<sup>®</sup> and placebo,
                respectively).<sup>6</sup>
                TOSS=total ocular symptom score.
              </p>
            </template>
          </accordion>

          <div class="text_container pt-40 mobile-pb-0 js-botTopFadeIn">
            <p class="text">Statistically significant reduction in combined nasal symptom and medication usage scores occurred as early as week 14 and continued throughout the year.<sup>8</sup></p>
          </div>

          <!--   CL   -->
          <div class="graph_container mobile-pt-0 pt-20 screen-object-1 js-botTopFadeIn">
            <graph-animation :data="animationsData['13']" class="desktop-anim graph--image full-graph"></graph-animation>
            <!--            <graph-animation :data="animationsData['14']" class="mobile-anim graph&#45;&#45;image full-graph"></graph-animation>-->
            <scroll-graph :patient="'gabrielle'" :srcID="14" :isHead="true" :text="'Reduction in TCRS* over 52 weeks'" class="mobile-anim" id="gabrielle-scroll-graph-1"></scroll-graph>

          </div>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote">DMS=daily medication score; <nobr>DSS=daily</nobr> symptom score; <nobr>TCRS=total</nobr> combined rhinitis score.</p>
            <p class="text text--footnote superscript-in-text"><span class="sup">*</span>TCRS is defined as the sum of the rhinitis DSS and the rhinitis DMS.</p>
            <p class="text text--footnote">Primary end point: During the last 8 weeks of treatment, ODACTRA<sup>®</sup> with symptomatic medications produced <nobr>a 16.1% reduction</nobr> in TCRS compared with symptomatic medications alone
              <nobr>(5.71 [n=318]</nobr> vs <nobr>
                6.81 [n=388]; 95%</nobr>
              <nobr>CI: −25.8%, −5.7%).<sup>7</sup></nobr></p>
          </div>

        </div>
        <quiz :patientName="this.GabrielleQuizData.name" :id='3'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.GabrielleQuizData.question[2].answered === true}]"></div>

    <!--  S4  -->
    <section-wrapper
        :class="this.GabrielleQuizData.name + '_patient_section_4'"
        :id="4"
        :patientName="this.GabrielleQuizData.name">
      <template slot="section">
        <div class="section">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.GabrielleQuizData.question[3].answered === true" id="tip_3">
              <p class="text text--quiz-info">HDMs may be the underlying allergen affecting patients like Gabrielle year-round when other allergens are not present. In this case, HDMs are acting as an “anchor” for Gabrielle, causing her symptoms
                during
                the non-pollen season.</p>
            </div>
          </transition>

          <div class="text_container pt-0 js-botTopFadeIn">
            <h2 class="lb_title">ODACTRA<sup>®</sup> treats the underlying cause of HDM allergy and not simply the symptoms.</h2>
          </div>

          <div class="text_container js-botTopFadeIn">
            <h2 class="section-title">ODACTRA<sup>®</sup> has statistically significant effects on HDM induced AR<sup>9</sup></h2>
          </div>

          <patient-tabs :tabData="this.tabDataGabrielle[3]" class="js-botTopFadeIn"></patient-tabs>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote superscript-in-text"><span class="sup">*</span>TCRS is defined as the sum of the rhinitis DSS and the rhinitis DMS.</p>
            <p class="text text--footnote">This study was designed to prove clinically significant reduction in symptoms and medication use by 15%, as defined by the FDA.<sup>7</sup></p>
          </div>

          <div class="text_container pt-60 js-botTopFadeIn">
            <h2 class="section-title">ODACTRA<sup>®</sup> has demonstrated efficacy throughout the year, including in polysensitized patients<sup>8</sup></h2>
          </div>

          <div class="text_container js-botTopFadeIn">
            <p class="text">Statistically significant reduction in combined nasal symptom and medication usage scores occurred as early as week 14 and continued throughout the year in polysensitized patients.<sup>8</sup></p>
          </div>

          <!--   CL   -->
          <div class="graph_container pt-0 screen-object-2 js-botTopFadeIn">
            <graph-animation :data="animationsData['15']" class="desktop-anim graph--image full-graph"></graph-animation>
            <!--            <graph-animation :data="animationsData['16']" class="mobile-anim graph&#45;&#45;image full-graph"></graph-animation>-->
            <scroll-graph :patient="'gabrielle'" :srcID="16" :isHead="true" :text="'Reduction in TCRS* over 52 weeks'" class="mobile-anim" id="gabrielle-scroll-graph-2"></scroll-graph>

          </div>
          <!--        -->

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote superscript-in-text"><span class="sup">*</span>TCRS is defined as the sum of the rhinitis DSS and the rhinitis DMS.</p>
            <p class="text text--footnote">Primary end point: During the last 8 weeks of treatment, ODACTRA<sup>®</sup> with symptomatic medications produced a 16.1% reduction in TCRS compared with symptomatic medications alone (5.71 [n=318] vs 6.81
              [n=388]; 95% CI: −25.8%,
              −5.7%).<sup>7</sup></p>
          </div>

          <div class="text_container js-botTopFadeIn">
            <p class="text">ODACTRA<sup>®</sup> significantly reduced AR symptoms and the use of AR medications<sup>7,8</sup></p>
          </div>

          <div class="double_container with-percent pt-10 js-botTopFadeIn">
            <div class="double_container-left">
              <img alt class="" src="@/assets/img/patients/joseph/reduction_1.svg"/>
            </div>
            <div class="double_container-right">
              <p class="text">ODACTRA<sup>®</sup> significantly reduced rhinitis DSS vs symptomatic medications alone
                (95% Cl: –23.8%, –3.9%; <nobr><i style="margin-right: 2px;">P</i>=.003)<sup>7,8</sup></nobr></p>
              <p class="text pt-10">AR symptoms that were measured included<sup>7</sup></p>
              <ul class="ul_container pt-5">
                <li class="text li-item">Runny nose</li>
                <li class="text li-item">Sneezing</li>
                <li class="text li-item">Blocked nose</li>
                <li class="text li-item">Itchy nose</li>
              </ul>
            </div>
          </div>
          <div class="double_container with-percent pt-40 js-botTopFadeIn">
            <div class="double_container-left">
              <img alt class="" src="@/assets/img/patients/joseph/reduction_2.svg"/>
            </div>
            <div class="double_container-right">
              <p class="text">ODACTRA<sup>®</sup> significantly reduced rhinitis DMS vs symptomatic medications alone
                (95% Cl: –34.7%, –1.3%; <nobr><i style="margin-right: 2px;">P</i>=.024)<sup>7</sup></nobr></p>
              <p class="text pt-10">AR medications that were measured included<sup>8</sup></p>
              <ul class="ul_container pt-5">
                <li class="text li-item">Oral antihistamine (desloratadine tablets, <nobr>5 mg)</nobr></li>
                <li class="text li-item">Nasal steroid (budesonide nasal spray, <nobr>64 mcg/dose)</nobr></li>
              </ul>
            </div>
          </div>

          <div class="text_container pt-40 js-botTopFadeIn">
            <accordion :group="'gabrielleGroup2'" :initialShow="true" :id="1" class="accordion accordion-2">
              <template slot="header">
                <p class="accordion_title unselectable">Study design</p>
                <img src="@/assets/img/accordion/arrow-bottom.svg" alt class="accordion-toggle unselectable">
              </template>
              <template slot="body">

                <div class="footnotes_container pt-0">
                  <p class="text text--footnote">A randomized, multinational, multicenter, placebo-controlled, double-blind trial was conducted for 52 weeks in patients aged 18 to 66 years with HDM-induced AR, with or without asthma, and
                    conjunctivitis
                    (N=656). Mean age (years) was 32.1 + 10.6 for ODACTRA<sup>®</sup> patients and 32.2 + 10.9 for placebo patients. There were 152 patients with HDM-induced allergic asthma for both ODACTRA<sup>®</sup> and placebo. Mean duration of
                    AR/conjunctivitis was 9.8 years and 10.0 years for ODACTRA<sup>®</sup> and placebo patients, respectively. Of ODACTRA<sup>®</sup> patients, 66% were polysensitized. Patients received ODACTRA<sup>®</sup> or placebo, with the
                    efficacy
                    assessment occurring during the last 8 weeks of treatment (October 1 through March 15) to avoid overlapping symptoms caused by pollen allergy. The primary efficacy end point was the average TCRS during the last 8 weeks of
                    treatment.
                    The
                    TCRS was the sum of the rhinitis DSS and rhinitis DMS. The rhinitis DSS was the sum of 4 nasal symptoms (runny nose, stuffy nose, sneezing, and itchy nose) scored on a scale of 0 (none) to 3 (severe). The rhinitis DMS was
                    calculated
                    based on daily use of symptom-relieving medications for nasal symptoms.<sup>7,8</sup></p>
                </div>

              </template>
            </accordion>
          </div>

          <div class="title_container pt-10 js-botTopFadeIn">
            <h2 class="section-title">Changes in Treatment</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item">Gabrielle was prescribed ODACTRA<sup>®</sup> for her HDM allergy, which is affordable even with her high deductible plan due to manufacturer’s copay assistance card</li>
              <li class="text li-item">She was also prescribed auto-injectable epinephrine and received instruction and training on its appropriate use</li>
              <li class="text li-item">The first dose of ODACTRA<sup>®</sup> was given in-office the following week</li>
            </ul>
          </div>

          <div class="title_container pt-40 js-botTopFadeIn">
            <h2 class="section-title">Follow-up</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <ul class="ul_container">
              <li class="text li-item">Compliance, epinephrine protocol/counselling, and any side effects were assessed at 4 weeks post-treatment</li>
              <li class="text li-item">Gabrielle tolerated ODACTRA<sup>®</sup> well and noticed a significant reduction in all of her symptoms at 14 weeks; SNOT-22 score decreased to 2 (mild)</li>
              <li class="text li-item">Gabrielle noticed sustained and stable reductions in symptoms by 40% at <nobr>24 to 52 weeks</nobr></li>
              <li class="text li-item">Discontinued antihistamine nasal spray and uses corticosteroid nasal spray only as needed</li>
              <li class="text li-item">Gabrielle only experiences symptoms in tree pollen season and can manage her symptoms with corticosteroid nasal spray</li>
            </ul>
          </div>

          <quote :patient="'gabrielle'" :blockID="4"></quote>

        </div>
        <quiz :patientName="this.GabrielleQuizData.name" :id='4'></quiz>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.GabrielleQuizData.question[3].answered === true}]"></div>

    <!--  S5  -->
    <section-wrapper
        :class="this.GabrielleQuizData.name + '_patient_section_5'"
        :id="5"
        :patientName="this.GabrielleQuizData.name">
      <template slot="section">
        <div class="section last-section" :class="{'isiStateMin' : this.isiState === 2}">

          <transition name="fade" mode="out-in">
            <div class="quiz_tip_block quiz_tip_block--new_design" v-if="this.GabrielleQuizData.question[4].answered === true" id="tip_4">
              <p class="text text--quiz-info">ODACTRA<sup>®</sup> has proven efficacy in mono- and polysensitized patients throughout the year.<sup>6-8</sup> ODACTRA<sup>®</sup> provides significant symptom relief and reduces the use of allergy
                rescue medications.<sup>7,8</sup> ODACTRA<sup>®</sup> has proven efficacy in HDM-induced AR and has been used extensively to treat persistent allergic rhinitis.<sup>10</sup> Clinical benefits with ODACTRA<sup>®</sup> may be seen within 8
                to 14
                weeks following initiation and ODACTRA<sup>®</sup> was effective regardless of sensitization status.<sup>6-8</sup> Adverse events with ODACTRA<sup>®</sup> were generally mild to moderate and local.</p>
            </div>
          </transition>

          <accordion :group="'gabrielleGroup3'" :id="1" :initialShow="false" class="accordion accordion-3 js-botTopFadeIn">
            <template slot="header">
              <p class="accordion_title unselectable">Set patient expectations on anticipated adverse events</p>
              <img src="@/assets/img/accordion/arrow-bottom.svg" alt class="accordion-toggle unselectable">
            </template>
            <template slot="body">
              <p class="text">Epinephrine use: As with all allergy immunotherapies, auto-injectable epinephrine is used to manage any serious adverse reactions that may occur, such as anaphylaxis, which can include trouble breathing, dizziness,
                nausea, vomiting, and diarrhea. In the clinical trials, use of epinephrine occurred at a rate <nobr>of 0.4% (5/1279)</nobr> for patients receiving ODACTRA<sup>®</sup> vs 0.2% (3/1277) for patients receiving placebo<sup>7,11</sup>
              </p>
              <ul class="ul_container pt-10">
                <li class="text li-item">AEs tended to be brief (median duration, 30-60 minutes), occurred early (within minutes of administration during the <nobr>first 1-7 days),</nobr> and were limited in recurrence (resolution <nobr>within
                  <2 weeks)<sup>7</sup></nobr></li>
                <li class="text li-item">Discontinuation rates: Overall discontinuation rates due to AEs were 8.1% and 3.0% for ODACTRA<sup>®</sup> and placebo, respectively<sup>7</sup></li>
              </ul>
              <div class="footnotes_container pt-0">
                <p class="text text--footnote">AE=adverse event.</p>
              </div>

              <div class="image_container pt-20 screen-object-3">
                <div class="swipe-icon_container">
                  <img src="@/assets/img/scrollgraph/swipe.svg" class="swipe-icon" alt>
                </div>
                <div class="scroll-table-head">
                  <p class="st_head-text">Percentage of solicited adverse reactions within 28 days after initiation of treatment <br><nobr>(Field Study<sup>1,*</sup></nobr> <nobr> Safety Analysis Set)<sup>12</sup></nobr></p>
                </div>
                <div id="table-scroll_gabrielle" class="table-scroll">
                  <div class="table-wrap">
                    <table class="table-gabrielle main-table">
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 table-gabrielle_col-1 table_title-text fixed-side">Adverse Reaction</td>
                        <td colspan="2" class="table-gabrielle_col-2 table_title-text">Adverse Reactions<br/>of Any Intensity</td>
                        <td colspan="2" class="table-gabrielle_col-3 table_title-text">Adverse Reaction<br/>That Were Severe</td>
                      </tr>
                      <tr class="table-gabrielle_row">
                        <td class="table-1_col-1 text fixed-side"></td>
                        <td class="table-1_col-2 text"><b>ODACTRA<sup>®</sup><br/>(n=640)</b></td>
                        <td class="table-1_col-2 text"><b>Placebo<br/>(n=631)</b></td>
                        <td class="table-1_col-3 text"><b>ODACTRA<sup>®</sup><br/>(n=640)</b></td>
                        <td class="table-1_col-3 text"><b>Placebo<br/>(n=631)</b></td>
                      </tr>
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 text fixed-side">Throat irritation/tickle</td>
                        <td class="table-1_col-2 text">67.0%</td>
                        <td class="table-1_col-2 text">20.8%</td>
                        <td class="table-1_col-3 text">0.3%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row">
                        <td class="table-1_col-1 text fixed-side">Itching in the mouth</td>
                        <td class="table-1_col-2 text">61.3%</td>
                        <td class="table-1_col-2 text">14.1%</td>
                        <td class="table-1_col-3 text">0.2%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 text fixed-side">Itching in the ear</td>
                        <td class="table-1_col-2 text">51.7%</td>
                        <td class="table-1_col-2 text">11.7%</td>
                        <td class="table-1_col-3 text">0.3%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row">
                        <td class="table-1_col-1 text fixed-side">Swelling of the uvula/back of <nobr>the mouth</nobr></td>
                        <td class="table-1_col-2 text">19.8%</td>
                        <td class="table-1_col-2 text">2.4%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 text fixed-side">Swelling of the lips</td>
                        <td class="table-1_col-2 text">18.0%</td>
                        <td class="table-1_col-2 text">2.7%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row">
                        <td class="table-1_col-1 text fixed-side">Swelling of the tongue</td>
                        <td class="table-1_col-2 text">15.8%</td>
                        <td class="table-1_col-2 text">2.1%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 text fixed-side">Nausea</td>
                        <td class="table-1_col-2 text">14.2%</td>
                        <td class="table-1_col-2 text">7.1%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row">
                        <td class="table-1_col-1 text fixed-side">Tongue pain</td>
                        <td class="table-1_col-2 text">14.2%</td>
                        <td class="table-1_col-2 text">3.0%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 text fixed-side">Throat swelling</td>
                        <td class="table-1_col-2 text">13.6%</td>
                        <td class="table-1_col-2 text">2.4%</td>
                        <td class="table-1_col-3 text">0.2%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row">
                        <td class="table-1_col-1 text fixed-side">Tongue ulcer/sore on the tongue</td>
                        <td class="table-1_col-2 text">11.6%</td>
                        <td class="table-1_col-2 text">2.1%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 text fixed-side">Stomach pain</td>
                        <td class="table-1_col-2 text">11.3%</td>
                        <td class="table-1_col-2 text">5.2%</td>
                        <td class="table-1_col-3 text">0.2%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row">
                        <td class="table-1_col-1 text fixed-side">Mouth ulcer/sore int mouth</td>
                        <td class="table-1_col-2 text">10.3%</td>
                        <td class="table-1_col-2 text">2.9%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 text fixed-side">Taste alteration/food tasted different</td>
                        <td class="table-1_col-2 text">10.0%</td>
                        <td class="table-1_col-2 text">3.6%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row">
                        <td class="table-1_col-1 text fixed-side">Diarrhea</td>
                        <td class="table-1_col-2 text">6.9%</td>
                        <td class="table-1_col-2 text">3.6%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                      <tr class="table-gabrielle_row grey-background">
                        <td class="table-1_col-1 text fixed-side">Vomiting</td>
                        <td class="table-1_col-2 text">2.5%</td>
                        <td class="table-1_col-2 text">1.4%</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                        <td class="table-1_col-3 text">&mdash;</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div class="footnotes_container pt-0">
                <p class="text text--footnote">*North American Field Efficacy Study.</p>
              </div>

            </template>
          </accordion>

          <div class="title_container pb-0 js-botTopFadeIn">
            <h2 class="section-title">Summary</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <ul class="ul_container pt-10">
              <li class="text li-item">Presence of perennial symptoms; symptoms exacerbated during the height of pollen season</li>
              <li class="text li-item">History of facial pressure, runny nose, scratchy sore throat, nasal congestion, difficulty breathing while sleeping, cough, itchy watery eyes, and ear pressure</li>
              <li class="text li-item">Gabrielle initiated AIT and preferred <nobr>SLIT-tablets</nobr> due to fast relief of symptoms relative to SCIT</li>
              <li class="text li-item">Gabrielle was an appropriate patient for ODACTRA<sup>®</sup> for the following reasons:
                <ul class="ul_sub_container">
                  <li class="text li-sub_item">A positive skin prick test for HDMs and other environmental allergens</li>
                  <li class="text li-sub_item">Despite seasonal pollen exacerbations, symptoms suggest a perennial and indoor element</li>
                  <li class="text li-sub_item">Desired a therapy with quick relief of symptoms relative to SCIT</li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="title_container js-botTopFadeIn">
            <h2 class="section-title">One tablet, once a day, for unique dosing flexibility</h2>
          </div>

          <div class="text_container pt-0 js-botTopFadeIn">
            <p class="text">Refer patients to Administration Instructions under “Patient Counseling Information” in the ODACTRA<sup>®</sup> Prescribing Information.</p>
          </div>

          <div class="fr_container js-botTopFadeIn">
            <div class="fr-content">
              <div class="fr-column fr-column--1">
                <img src="@/assets/img/patients/orange-people.svg" class="fr-image" alt>
                <p class="text text--fr">Administer first dose in a health care setting under the supervision of a medical professional<sup>7</sup></p>
              </div>
              <div class="h-divider">
                <span class="divider"></span>
              </div>
              <div class="fr-column fr-column--2">
                <img src="@/assets/img/patients/orange-clock.svg" class="fr-image" alt>
                <p class="text text--fr">Observe the patient for at least <nobr>30 minutes</nobr> to monitor for signs or symptoms of a severe systemic or local allergic reaction<sup>7</sup></p>
              </div>
              <div class="h-divider">
                <span class="divider"></span>
              </div>
              <div class="fr-column fr-column--3">
                <img src="@/assets/img/patients/orange-house.svg" class="fr-image" alt>
                <p class="text text--fr">If patient tolerates the first dose, subsequent doses may be taken at home<sup>7,*</sup></p>
              </div>
              <div class="h-divider">
                <span class="divider"></span>
              </div>
              <div class="fr-column fr-column--4">
                <img src="@/assets/img/patients/orange-point.svg" class="fr-image" alt>
                <p class="text text--fr">Practice parameters recommend that patients receiving AIT for HDM allergens be treated for 3 to 5 years to obtain maximum benefits<sup>12</sup></p>
              </div>
            </div>
          </div>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote superscript-in-text"><span class="ml-3 sup">*</span>Data regarding the safety of restarting treatment after missing a dose of ODACTRA are limited. If a missed dose occurs, it is recommended that the next dose
              be taken at the
              normally scheduled time. If more than one dose is missed, patients should contact their physician to discuss re-initiation. In
              clinical trials, treatment interruptions for up to 7 days were allowed.<sup>7</sup></p>
          </div>

          <div class="title_container pt-60 js-botTopFadeIn">
            <h2 class="global-title">ALK Support Program</h2>
          </div>

          <div class="title_container pt-10 js-botTopFadeIn">
            <h2 class="section-title">ELIGIBLE PATIENTS MAY PAY AS LITTLE AS $25. CLICK TO FIND OUT MORE.</h2>
          </div>

<!--          <div class="text_container pt-0 js-botTopFadeIn">-->
<!--            <p class="text">Eligible patients may pay as little as $25.</p>-->
<!--          </div>-->

          <div class="image_container js-botTopFadeIn">
            <a href="https://www.alksavings.com/" target="_blank">
              <img src="@/assets/img/patients/susan/ALKSupportProgram.png" alt class="image">
            </a>
          </div>

          <quote :patient="'gabrielle'" :blockID="5" class="js-botTopFadeIn"></quote>

          <footer-buttons class="pt-0 js-botTopFadeIn"></footer-buttons>

          <div class="footnotes_container pt-0 js-botTopFadeIn">
            <p class="text text--footnote">Patients should read all of the instructions for use provided under the patient information section in the Full Prescribing Information before using ODACTRA<sup>®</sup> for the first time.</p>
          </div>

          <div class="text_container pt-40 js-botTopFadeIn">
            <accordion :initialShow="false" :group="'gabrielleGroup4'" :id="1" class="accordion accordion-4">
              <template slot="header">
                <p class="accordion_title unselectable">References</p>
                <img src="@/assets/img/accordion/arrow-bottom.svg" alt class="accordion-toggle unselectable">
              </template>
              <template slot="body">

                <p class="block-black-title pb-0">References</p>
                <ul class="ul_container number-ul">
                  <li class="text li-item">Data on file. ALK-Abelló A/S.</li>
                  <li class="text li-item">Compalati E, Ridolo E, Passalacqua G, et al. The link between allergic rhinitis and asthma: the united airways disease. <i>Expert Rev Clin Immunol</i>. 2010;6(3):413-423.</li>
                  <li class="text li-item">Feng CH, Miller MD, Simon RA. The united allergic airway: connections between allergic rhinitis, asthma, and chronic sinusitis. <i>Am J Rhinol Allergy</i>. 2012;26(3):187-190.</li>
                  <li class="text li-item">Sporik R, Holgate ST, Platts-Mills TA, Dogswell JJ. Exposure to house dust mite allergen (Der p1) and the development of asthma in childhood. <i>N Engl J Med</i>. 1990;323(8):502-507.</li>
                  <li class="text li-item">Colloff MJ. <i>Dust Mites</i>. Dordrecht, the Netherlands: Springer Nature; 2009.</li>
                  <li class="text li-item">Nolte H, Maloney J, Nelson HS, et al. Onset of dose-related efficacy of house dust mites sublingual immunotherapy tablets in an environmental exposure chamber. <i>J Allergy Clin. Immunol</i>. 2015;
                    135(6):1494-1501.e6.
                  </li>
                  <li class="text li-item">ODACTRA [Prescribing Information]. Hørsholm, Denmark: ALK; 2017.</li>
                  <li class="text li-item">Demoly P, Emminger W, Rehm D, et al. Effective treatment of house dust mite-induced allergic rhinitis with 2 doses of the SQ HDM SLIT-tablet: results from a randomized, double-blind, placebo-controlled
                    phase
                    III trial. <i>J Allergy Clin Immunol</i>. 2016;137(2):444-451.
                  </li>
                  <li class="text li-item">Nolte H, Bernstein DI, Nelson HS, et al. Efficacy of house dust mite sublingual immunotherapy tablet in North American adolescents and adults in a randomized, placebo-controlled trial. <i>J Allergy Clin
                    Immunol</i>. 2016;138(6):1631-1638.
                  </li>
                  <li class="text li-item">Data on file. Merck Sharp & Dohme Corp. Whitehouse Station, NJ: 2017.</li>
                  <li class="text li-item">American College of Allergy, Asthma, and Immunology. Anaphylaxis. http://www.acaai.org/allergies/anaphylaxis. Accessed June 29, 2020.</li>
                  <li class="text li-item">Portnoy J, Miller JD, Williams PB, et al; Joint Taskforce on Practice Parameters; Practice Parameter Workgroup. Environmental assessment and exposure control of dust mites: a practice parameter. <i>Ann
                    Allergy Asthma Immunol</i>. 2013;111(6):465-507.
                  </li>
                </ul>

              </template>
            </accordion>
          </div>

          <Footer class="js-botTopFadeIn"></Footer>

        </div>
      </template>
    </section-wrapper>
    <div :class="['section-divider', {'section-divider-active': this.GabrielleQuizData.question[4].answered === true}]"></div>

  </div>
</template>

<script>
import PatientBase from './patient_base';
import { mapState } from 'vuex';

export default {
  name: 'Gabrielle',
  extends: PatientBase,
  computed: {
    ...mapState(['userAgent', 'tabDataGabrielle']),
    ...mapState({
      GabrielleQuizData: state => state.quizData.patients.gabrielle,
      GabrielleData: state => state.patients.gabrielle
    }),
  },
  mounted() {
  },
  updated() {
    if (document.querySelector('#table-scroll_gabrielle .main-table')
        && !document.querySelector('#table-scroll_gabrielle .main-table.table-clone')
        && document.querySelectorAll('.table-gabrielle.main-table.table-clone').length <= 1) {
      let cloneTable = document.querySelector('#table-scroll_gabrielle .main-table').cloneNode(true);
      cloneTable.classList.add('table-clone');
      document.getElementById('table-scroll_gabrielle').appendChild(cloneTable);
      document.querySelectorAll('.table-gabrielle.main-table')[0].classList.add('default-table');
    }
  }
};
</script>

<style lang="scss"></style>
